import { tipSade } from "./weld-map.js";
import { wpsSade } from "./wpq.js";
/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). Üç cins (WPS, PQR, dolgu onayı) tek türdür. */
export const WPS_BELGE_TURU = "wps_belgesi";
/** Okunan Documents türleri (GELEN_TURLERI anahtarları; Registers grubu, kütük sınıfı). */
export const WPS_GELEN_TURU = "kutuk:wps:wps";
export const PQR_GELEN_TURU = "kutuk:wps:pqr";
export const DOLGU_GELEN_TURU = "kutuk:wps:dolgu_onayi";
export const wpsBelgesiGelenTuruMu = (t) => t === WPS_GELEN_TURU || t === PQR_GELEN_TURU || t === DOLGU_GELEN_TURU;
export const wpsCinsi = (t) => t === WPS_GELEN_TURU ? "wps" : t === PQR_GELEN_TURU ? "pqr" : t === DOLGU_GELEN_TURU ? "dolgu" : null;
/** Cinsin WPS kütüğündeki belge türü (`GelenHedef.belgeTuru`). */
export const WPS_CINS_KUTUK_TURU = { wps: "wps", pqr: "pqr", dolgu: "dolgu_onayi" };
/** Cinsin Documents türü. */
export const WPS_CINS_GELEN_TURU = { wps: WPS_GELEN_TURU, pqr: PQR_GELEN_TURU, dolgu: DOLGU_GELEN_TURU };
/** Olay kaydında nesne tipi (nesneId = wps_belgesi_kaydi.id). */
export const WPS_OLAY_NESNESI = "wps_belgesi_kaydi";
/** Okunan hafif excel'in belge ailesi. Hiçbir aile sorgusu bu adı almaz (Riser Documentation, kanıt zinciri ve aile işlemleri). */
export const WPS_GIRDI_AILESI = "WPS-document-input";
/** DOCUMENT sayfasındaki "Document type" değerleri. */
export const WPS_EXCEL_ADI = "WPS";
export const PQR_EXCEL_ADI = "PQR";
export const DOLGU_EXCEL_ADI = "Filler metal approval";
/** Okuma işi kodu ("PROC-5A1B2C3D"); "WPS-" uyarı kodlarından ve "WPQR-" kodundan ayrı. */
export const wpsBelgesiKodu = (kayitId) => `PROC-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/** WPS'in alanları (DOCUMENT, 10; sabit sıra; sözleşme §11.3, sürüm 1). `etiket` hem ekran metni hem DOCUMENT'teki Field adıdır. Kimlik: WPS no. */
export const WPS_ALANLARI = [
    { alan: "wps_no", etiket: "WPS number", kimlik: true }, { alan: "rev", etiket: "Revision", kimlik: false },
    { alan: "prosesler", etiket: "Processes", kimlik: false }, { alan: "kok_araligi", etiket: "Root gap (mm)", kimlik: false },
    { alan: "kok_yuzu", etiket: "Root face (mm)", kimlik: false }, { alan: "aci", etiket: "Bevel angle (°)", kimlik: false },
    { alan: "kacilik", etiket: "Hi-Lo max (mm)", kimlik: false }, { alan: "on_isitma", etiket: "Min preheat (°C)", kimlik: false },
    { alan: "paso_arasi", etiket: "Max interpass (°C)", kimlik: false }, { alan: "pwht_saat", etiket: "Max PWHT time (hr)", kimlik: false },
];
/** PQR'ın alanları (DOCUMENT, 2). Kimlik: PQR no. */
export const PQR_ALANLARI = [
    { alan: "pqr_no", etiket: "PQR number", kimlik: true }, { alan: "tanik_damgasi", etiket: "Witness stamp", kimlik: false },
];
/** Dolgu onay sayfasının alanları (DOCUMENT, 1). Kimlik: WPS no. */
export const DOLGU_ALANLARI = [{ alan: "wps_no", etiket: "WPS number", kimlik: true }];
/** Dolgu satırı alanları (ROWS `Table = Filler`, satır başına 2; WPS'te ve dolgu onayında). */
export const WPS_DOLGU_SATIR_ALANLARI = [
    { alan: "sinif", etiket: "Class", kimlik: false }, { alan: "ticari_ad", etiket: "Trade name", kimlik: false },
];
/** Dayanak PQR satırı alanları (ROWS `Table = PQR`, satır başına 1; yalnız WPS'te). */
export const WPS_PQR_SATIR_ALANLARI = [{ alan: "pqr_no", etiket: "PQR number", kimlik: false }];
/** Alanın ekran adı (beş listede aranır); bilinmiyorsa alanın kendisi. */
export const wpsBelgesiEtiketi = (alan) => [...WPS_ALANLARI, ...PQR_ALANLARI, ...DOLGU_ALANLARI, ...WPS_DOLGU_SATIR_ALANLARI, ...WPS_PQR_SATIR_ALANLARI]
    .find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS başlığı (uzun biçim: her hücre bir satır; `Table` iki tablodan biri; PR 15 WPQ_SATIR_BASLIKLARI ile aynı biçim). */
export const WPS_SATIR_BASLIKLARI = ["Table", "Row", "Field", "Value", "As written", "Page", "Certainty"];
export const WPS_TABLOLARI = { dolgu: "Filler", pqr: "PQR" };
/** Bir belgede en çok dolgu ve dayanak PQR satırı (`Row`). */
export const WPS_DOLGU_EN_COK = 10;
export const WPS_PQR_EN_COK = 5;
/** `Witness stamp` hücresinin yalnız iki değeri. */
export const TANIK_DEGERLERI = { tanikli: "Witnessed", incelendi: "Reviewed" };
/** Fark listesinin satırları (M9-11; sabit sıra). Anahtarlar Registers'taki WPS kaydının alanlarıdır (`rg`, `rf`, `bv`, `hiloMax`, `ph` ölçüm şartlarıdır). */
export const WPS_FARK_ALANLARI = ["rev", "proc", "preheatMin", "interMax", "pwhtMax", "rg", "rf", "bv", "hiloMax", "ph"];
/** Fark satırının etiketi: Registers'taki İngilizce alan adı (WPS-03 cümlesinde `{0}`). */
export const WPS_FARK_ETIKETI = {
    rev: "Revision", proc: "Processes", preheatMin: "Min preheat (°C)", interMax: "Max interpass (°C)", pwhtMax: "Max cumulative PWHT (hr)", rg: "Root gap (mm)",
    rf: "Root face (mm)", bv: "Bevel angle (°)", hiloMax: "Hi-Lo (mm)", ph: "Preheat (measurement ranges)",
};
/** Fark satırının okunan alanı. */
export const WPS_FARK_KAYNAGI = {
    rev: "rev", proc: "prosesler", preheatMin: "on_isitma", interMax: "paso_arasi", pwhtMax: "pwht_saat", rg: "kok_araligi", rf: "kok_yuzu", bv: "aci", hiloMax: "kacilik",
    ph: "on_isitma",
};
/* ---------------- değer biçimleri (yalnız kesin değerler kullanılır) ---------------- */
/** PQR numarası da sondaki rev ve boşluklar atılarak karşılaştırılır; WPS koduyla aynı biçim. */
export const pqrSade = wpsSade;
/** Ticari adın karşılaştırma anahtarı: büyük harf, harf ve rakam dışı her şey atılır ("Demo Rod 70" → "DEMOROD70"). */
export const ticariSade = (v) => (v ?? "").toUpperCase().replace(/[^A-Z0-9]/g, "");
const SAYI = /^\d+(\.\d+)?$/;
/** Aralık: "N" ya da "N-M" (boşluk serbest, noktalı ondalık, N ≤ M, ≥ 0). Öteki her yazım null ("3,5", "3–5 mm"). */
export function aralikOku(v) {
    const s = (v ?? "").trim();
    const m = /^(\d+(?:\.\d+)?)(?:\s*-\s*(\d+(?:\.\d+)?))?$/.exec(s);
    if (!m)
        return null;
    const a = Number(m[1]);
    const b = m[2] !== undefined ? Number(m[2]) : a;
    return Number.isFinite(a) && Number.isFinite(b) && a <= b ? [a, b] : null;
}
/** Sayı: "N" (noktalı ondalık); öteki her yazım null ("1,6"). */
export function sayiOku(v) {
    const s = (v ?? "").trim();
    return SAYI.test(s) ? Number(s) : null;
}
/** `Min preheat (°C)`: sayı ya da "Ambient" (büyük-küçük harfe duyarsız); öteki her yazım null ("100 °C"). */
export function onIsitmaOku(v) {
    const s = (v ?? "").trim();
    if (/^ambient$/i.test(s))
        return { tur: "ortam" };
    const n = sayiOku(s);
    return n === null ? null : { tur: "sayi", deger: n };
}
/** `Witness stamp`: yalnız tam "Witnessed" / "Reviewed" (büyük-küçük harfe duyarsız); öteki her yazım null. */
export function tanikOku(v) {
    const s = (v ?? "").trim().toLowerCase();
    if (s === TANIK_DEGERLERI.tanikli.toLowerCase())
        return "tanikli";
    if (s === TANIK_DEGERLERI.incelendi.toLowerCase())
        return "incelendi";
    return null;
}
const kesinDeger = (l, alan) => {
    const d = l.find((x) => x.alan === alan);
    return d && d.kesinlik === "kesin" && d.deger !== null && d.deger.trim() ? d.deger.trim() : null;
};
/** Okumaların dolgu satırlarından liste (yalnız kesin değerler, tekil): sınıflar `tipSade`, ticari adlar `ticariSade`. */
export function wpsDolguListesiKur(okumalar) {
    const siniflar = [];
    const ticariAdlar = [];
    for (const o of okumalar) {
        for (const s of o.dolgular ?? []) {
            const sinif = tipSade(kesinDeger(s.degerler, "sinif"));
            if (sinif && !siniflar.includes(sinif))
                siniflar.push(sinif);
            const ad = ticariSade(kesinDeger(s.degerler, "ticari_ad"));
            if (ad && !ticariAdlar.includes(ad))
                ticariAdlar.push(ad);
        }
    }
    return { siniflar, ticariAdlar, belge: okumalar.length };
}
/* ---------------- uyarılar ---------------- */
/** Kartta üretilen kodlar (üretim sırası: kırmızı, kırmızı, sarı, gri, gri). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). WPS-02, WPS-06 ve SARF-03 weld map'te üretilir. */
export const WPS_BELGESI_UYARI_KODLARI = ["WPS-01", "WPS-03", "WPS-04", "WPS-05", "GEN-11"];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). */
export const WPS_BELGESI_UYARI_KALIPLARI = {
    "WPS-01": "Revision differs from Registers: document rev {0}, register rev {1}.",
    "WPS-03": "WPS values differ from the register: {0} {1} / {2}.",
    "WPS-04": "Supporting PQR not in Registers: {0}.",
    "WPS-05": "PQR stamp says Reviewed, not Witnessed.",
    "GEN-11": "Newer version of {0}. Mark the old one Superseded?",
};
//# sourceMappingURL=wps-belgesi.js.map